export default {
  breadcrumbAriaLabel: {
    id: 'buyback_breadcrumb_aria_label',
    defaultMessage: 'Breadcrumb product page trade in',
  },
}
